document.addEventListener('DOMContentLoaded', () => {
  function _doCarousel(block) {
    const sectionId = block.dataset.sectionId

    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 1.25,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'progressbar'
      },
      breakpoints: {
        550: {
          slidesPerView: 2.25,
        },
        750: {
          slidesPerView: 2.75,
        },
        990: {
          slidesPerView: 2.75,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
        },
        1100: {
          slidesPerView: 3.25,
          slidesOffsetAfter: 40,
          slidesOffsetBefore: 40,
        }
      }
    }

    const swiperObj = new Swiper(`.js-testimonials-carousel-${sectionId}`, option)
    swiperObj.init()
  }

  function buildTestimonialsCarousel() {
    const $carousels = document.querySelectorAll('.js-testimonials-wrapper')
    for (const $carousel of $carousels) {
      _doCarousel($carousel)
    }
  }

  buildTestimonialsCarousel()

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', buildTestimonialsCarousel)
  }
})
